import { SEARCH_SERVICES, CLEAR_SEARCH } from '../actions/Types'
const SearchReducer = (state=[], action) => {
    if (action.type === SEARCH_SERVICES){
        return action.payload
    }
    else if (action.type === CLEAR_SEARCH){
        return action.payload
    }
    else {
        return state
    }

}

export default SearchReducer